import { FilesUpload, FilesUploadProps } from 'libs/ui';

import { useFilesUploadFeature } from './useFilesUploadFeature';

/**
 * Props for the UploadFiles component.
 */
export interface FilesUploadFeatureProps
  extends Omit<
    FilesUploadProps<any>,
    'onAddFiles' | 'onRemoveFile' | 'files' | 'isError'
  > {
  name: string;
}

export const FilesUploadFeature = ({
  name,
  className,
  title,
  subtitle,
  fileTypes,
  maxFiles,
  defaultExpandFileList,
}: FilesUploadFeatureProps) => {
  const { files, isError, onAddFiles, onRemoveFile } = useFilesUploadFeature({
    name,
  });

  return (
    <FilesUpload
      className={className}
      defaultExpandFileList={defaultExpandFileList}
      files={files?.map((file) => ({
        ...file,
        loading: false,
        id: file.id!,
        fileInfo: { name: file.name || '', size: file.size || 0 },
      }))}
      fileTypes={fileTypes}
      isError={isError}
      maxFiles={maxFiles}
      name={name}
      subtitle={subtitle}
      title={title}
      onAddFiles={onAddFiles}
      onRemoveFile={(file) => onRemoveFile(file.id)}
    />
  );
};
